import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { AppProviders } from './app/AppProviders'
import { router } from './app/router'
import { AIAnimationBanner } from './shared/components/AIAnimationBanner'
import './shared/lib/i18n'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProviders>
      <AIAnimationBanner />
      <RouterProvider router={router} />
    </AppProviders>
  </React.StrictMode>,
)